module.exports = __webpack_public_path__ + "img/mayas_addition.a261d648.png";